import { render, staticRenderFns } from "./updHsfp.vue?vue&type=template&id=97962a1c"
import script from "./updHsfp.vue?vue&type=script&lang=js"
export * from "./updHsfp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports